import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_SALE_SETTLEMENT} from '@web/core/routes'
import {changeBrowserLocation} from '@web/helpers/browser'
import {push} from '@web/slices/router'

import {LocationChangeHistoryWithRouteParam, NavigationResult, ThunkApi} from '../interfaces'

/** 지급 보류 상세 내역 화면 이동 */
const navigateToSettlementPayHold = createAsyncThunk<
    NavigationResult,
    LocationChangeHistoryWithRouteParam,
    ThunkApi<unknown>
>('navigateTo/settlement/payhold', ({historyType = 'PUSH', routeBased = false}, {dispatch}) => {
    if (routeBased) {
        dispatch(push(ROUTER_ORDER_SALE_SETTLEMENT.PAY_HOLD.getPath(''), {resetScroll: routeBased}))
    } else {
        changeBrowserLocation({url: ROUTER_ORDER_SALE_SETTLEMENT.PAY_HOLD.getPath(''), type: historyType})
    }
})

export default navigateToSettlementPayHold
